<template>
  <v-navigation-drawer
    v-model="show"
    disable-route-watcher
    fixed
    floating
    right
    temporary
    height="100vh"
    class="elevation-5"
  >
    <!-- The content -->
    <v-container fluid>
      <!-- The title of the sidebar -->
      <v-layout class="mb-4">
        <v-flex
          class="text-xs-center blue-grey--text headline font-weight-light"
        >
          Ranking
          <v-btn icon absolute right @click="getClassificationRanking">
            <v-icon color="blue-grey">refresh</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <!-- A spinner to show while loading -->
      <v-layout v-if="loading.classRanking" class="my-5">
        <v-flex class="text-xs-center">
          <v-pulse-loader :loading="loading.classRanking" />
        </v-flex>
      </v-layout>
      <!-- The products -->
      <v-layout v-else wrap>
        <label
          class="text-xs-center blue-grey--text subheading font-weight-light"
          >Homologacion diaria</label
        >
        <v-list dense xs12 sm6 offset-sm3>
          <v-list-tile
            v-for="(item, index) in classRanking.dailyHomologation"
            :key="index"
          >
            <v-list-tile-action>
              <v-icon v-if="item.idx == 0" color="pink">emoji_events</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title
                v-text="item.Etiquetador.replace('@qmatch.cl', '')"
              ></v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action v-text="item.Total"> </v-list-tile-action>
          </v-list-tile>
          <v-divider />
        </v-list>

        <label
          class="text-xs-center blue-grey--text subheading font-weight-light"
          >Homologacion mensual</label
        >
        <v-list dense xs12 sm6 offset-sm3>
          <v-list-tile
            v-for="(item, index) in classRanking.monthlyHomologation"
            :key="index"
          >
            <v-list-tile-action>
              <v-icon v-if="item.idx == 0" color="pink">emoji_events</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title
                v-text="item.Etiquetador.replace('@qmatch.cl', '')"
              ></v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action v-text="item.Total"> </v-list-tile-action>
          </v-list-tile>
          <v-divider />
        </v-list>

        <label
          class="text-xs-center blue-grey--text subheading font-weight-light"
          >Clasificacion diaria</label
        >
        <v-list dense xs12 sm6 offset-sm3>
          <v-list-tile
            v-for="(item, index) in classRanking.dailyClassification"
            :key="index"
          >
            <v-list-tile-action>
              <v-icon v-if="item.idx == 0" color="pink">emoji_events</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title
                v-text="item.Etiquetador.replace('@qmatch.cl', '')"
              ></v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action v-text="item.Total"> </v-list-tile-action>
          </v-list-tile>
          <v-divider />
        </v-list>

        <label
          class="text-xs-center blue-grey--text subheading font-weight-light"
          >Clasificacion mensual</label
        >
        <v-list dense xs12 sm6 offset-sm3>
          <v-list-tile
            v-for="(item, index) in classRanking.monthlyClassification"
            :key="index"
          >
            <v-list-tile-action>
              <v-icon v-if="item.idx == 0" color="pink">emoji_events</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title
                v-text="item.Etiquetador.replace('@qmatch.cl', '')"
              ></v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action v-text="item.Total"> </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-layout>
    </v-container>
  </v-navigation-drawer>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapMutations, mapState } =
  createNamespacedHelpers("classifier");

// import VItemCard from "./ItemCard";
import VPulseLoader from "vue-spinner/src/PulseLoader";

export default {
  components: {
    // VItemCard,
    VPulseLoader,
  },
  data: () => ({
    rowsPerPageItems: [4, 8, 12],
    pagination: {
      rowsPerPage: 4,
      sortBy: "Total",
      descending: true,
    },
  }),
  computed: {
    ...mapState(["loading", "classRanking", "showClassRankingSidebar"]),
    show: {
      get() {
        return this.showClassRankingSidebar;
      },
      set(value) {
        this.setShowClassRankingSidebar(value);
      },
    },
  },
  watch: {
    show() {
      if (this.show && !this.classRanking.length) {
        this.getClassificationRanking();
      }
    },
  },
  methods: {
    ...mapActions(["getClassificationRanking"]),
    ...mapMutations(["setShowClassRankingSidebar"]),
  },
};
</script>